import React, { useEffect } from "react";
import { Reveal } from "../../Components/Reveal/Reveal";
import "./style.css";
import { ContactSection } from "../../Components/ContactSection/ContactSection";
import { Helmet } from "react-helmet-async";
import { WhyChooseDataDept } from "../../Components/WhyChooseClifster/WhyChooseClifster";
export const Faq = (prop) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    prop.setSelectedPage("faq");
  }, []);

  return (
    <>
      <Helmet>
        <title>
          FAQ - DataDept | Answers to Your Questions: Frequently Asked Questions
          (FAQ)
        </title>
        <meta
          name="description"
          content="Find answers to your questions about custom software development, CRM, mobile apps, and SaaS solutions on our FAQ page. Get insights and support from DataDept's experts."
        />
        <link rel="canonical" href="/faq" />
      </Helmet>
      <section className="about-page-section-1 container-style">
        <div className="content-sizing about-page-section-1-wrapper">
          <div className="header-into-about-section">
            <Reveal delay={0.1}>
              <span className="light-tag">FAQ</span>
            </Reveal>
            <Reveal delay={0.2}>
              <h1 className="header-tag-about">
                Our expert team gives answers to your common questions
              </h1>
            </Reveal>
            <Reveal delay={0.3}>
              <h2 className="sub-header-tag-about">
                Welcome to our FAQs section, where we address the most common
                questions and queries our clients and visitors often have.
              </h2>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="about-page-section-2 container-style">
        <div className="content-sizing about-page-section-2-wrapper">
          <div className="about-box-company-header">
            <div className="header-left-about-2">
              <span className="small-tag">FAQ SECTION</span>
              <h2>Frequently asked questions</h2>
            </div>
          </div>

          <ul className="faq-list-item">
            <Reveal delay={0.1}>
              <li className="single-question-faq">
                <div className="icon-container-faq">
                  <i className="bi bi-code-square"></i>
                </div>
                <div className="faq-content-item-box">
                  <h3>What Is Custom Software Development?</h3>
                  <p>
                    Custom software development involves crafting tailored
                    solutions for specific user needs, offering more efficient
                    and effective results than off-the-shelf options.
                  </p>
                </div>
              </li>
            </Reveal>
            <Reveal delay={0.15}>
              <li className="single-question-faq">
                <div className="icon-container-faq">
                  <i className="bi bi-journal-code"></i>
                </div>
                <div className="faq-content-item-box">
                  <h3>
                    What Distinguishes SaaS Development from Traditional
                    Software?
                  </h3>
                  <p>
                    SaaS product development creates scalable, cloud-based
                    applications with subscription-based billing, contrasting
                    with traditional on-premises software creation.
                  </p>
                </div>
              </li>
            </Reveal>
            <Reveal delay={0.2}>
              <li className="single-question-faq">
                <div className="icon-container-faq">
                  <i className="bi bi-cloud-check"></i>
                </div>
                <div className="faq-content-item-box">
                  <h3>What Benefits Do Cloud Solutions Offer Businesses?</h3>
                  <p>
                    Cloud solutions enhance business efficiency, scalability,
                    and accessibility, reducing IT costs and allowing operations
                    to adjust swiftly to demand.
                  </p>
                </div>
              </li>
            </Reveal>

            <Reveal delay={0.3}>
              <li className="single-question-faq">
                <div className="icon-container-faq">
                  <i className="bi bi-shield-lock"></i>
                </div>
                <div className="faq-content-item-box">
                  <h3>How to Future-Proof Your Software Solution?</h3>
                  <p>
                    Future-proofing your software requires using flexible
                    technologies, adhering to best practices, and updating
                    regularly to stay ahead of trends.
                  </p>
                </div>
              </li>
            </Reveal>

            <Reveal delay={0.3}>
              <li className="single-question-faq">
                <div className="icon-container-faq">
                  <i className="bi bi-check2-circle"></i>
                </div>
                <div className="faq-content-item-box">
                  <h3>How Does DataDept Guarantee Software Quality?</h3>
                  <p>
                    DataDept guarantees software excellence with thorough
                    testing, continuous practices, and strict industry
                    standards, ensuring robust, secure, and efficient solutions.
                  </p>
                </div>
              </li>
            </Reveal>

            <Reveal delay={0.3}>
              <li className="single-question-faq">
                <div className="icon-container-faq">
                  <i className="bi bi-cloud-upload"></i>
                </div>
                <div className="faq-content-item-box">
                  <h3>
                    Can DataDept help migrate my existing application to the
                    cloud?
                  </h3>
                  <p>
                    Yes, DataDept specializes in helping businesses migrate
                    their existing applications to the cloud. Our comprehensive
                    cloud migration services include assessing your current
                    infrastructure, planning the migration, executing the move
                    with minimal downtime, and optimizing your new cloud
                    environment for performance and cost.
                  </p>
                </div>
              </li>
            </Reveal>
          </ul>
        </div>
      </section>

      <WhyChooseDataDept />
    </>
  );
};
